var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav-menu-category', _vm._g(_vm._b({
    attrs: {
      "name": "Greeting cards",
      "fragment": "greeting-cards",
      "icon": _vm.mdiCards
    }
  }, 'nav-menu-category', _vm.$attrs, false), _vm.$listeners));

}
var staticRenderFns = []

export { render, staticRenderFns }